<h1 mat-dialog-title>
  {{ ("selectDateRange" | i18n) || "Select date range" }}
</h1>
<div mat-dialog-content>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ ("from" | i18n) || "from" | titlecase }}</mat-label>
        <input
          matInput
          [value]="fromDate | date"
          readonly
          (click)="fromDatePicker.open()"
          required
          data-cy="date-range-from-input" />
        <input
          matInput
          name="fromDate"
          required
          [matDatepicker]="fromDatePicker"
          [(ngModel)]="fromDate"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ ("to" | i18n) || "to" | titlecase }}</mat-label>
        <input
          matInput
          [value]="toDate | date"
          readonly
          (click)="toDatePicker.open()"
          required
          data-cy="date-range-to-input" />
        <input
          matInput
          [min]="fromDate"
          name="toDate"
          required
          [matDatepicker]="toDatePicker"
          [(ngModel)]="toDate"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="toDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #toDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    (click)="onNoClick()">
    {{ ("cancel" | i18n) || "cancel" | uppercase }}
  </button>
  <button
    mat-button
    [disabled]="!fromDate || !toDate"
    (click)="onYesClick()"
    data-cy="date-range-submit-dialog-button">
    {{ ("save" | i18n) || "save" | uppercase }}
  </button>
</div>
